export default __webpack_public_path__ + "static/media/bnp.bcdf1d59.svg";